import { render, staticRenderFns } from "./card-meuspedidos.vue?vue&type=template&id=3064507a&scoped=true"
import script from "./card-meuspedidos.vue?vue&type=script&lang=js"
export * from "./card-meuspedidos.vue?vue&type=script&lang=js"
import style0 from "./card-meuspedidos.vue?vue&type=style&index=0&id=3064507a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3064507a",
  null
  
)

export default component.exports